module.exports = __webpack_public_path__ + "img/en.48fd62fa.png";